import { SmartPillData } from 'owa-smart-pill';
import getSmartPillsFeatureArrangements from 'owa-mail-smart-pill-features/lib/utils/getSmartPillsFeatureArrangements';
import {
    SmartPillsAggregatedByFeature,
    SmartPillsFeatureArrangement,
} from 'owa-mail-smart-pill-features';
import aggregateSmartFeaturesFromPills from './aggregateSmartFeaturesFromPills';

/**
 *    It selects an SmartPillsFeatureArrangement based on the number of pills by feature found
 *    @param pills: Flat array of smart pills from mail stamp
 */
export default function selectSmartFeatureArrangement(
    pills: SmartPillData[]
): SmartPillsFeatureArrangement {
    if (pills) {
        const aggregatedPills: SmartPillsAggregatedByFeature = aggregateSmartFeaturesFromPills(
            pills
        );

        const allFeatureArrangements: SmartPillsFeatureArrangement[] = getSmartPillsFeatureArrangements();

        // Checks if an email item contains features that can be identified from the predefined arrangement
        for (let i = 0; i < allFeatureArrangements.length; i++) {
            let foundMatch: boolean = true;

            const featureArrangement: SmartPillsFeatureArrangement = allFeatureArrangements[i];

            // It loops thru every feature and its number of pills
            for (let j = 0; j < featureArrangement.arrangement.length; j++) {
                // Number of pills from the business arrangement
                const numOfPillsDefined: number =
                    featureArrangement.aggregation[featureArrangement.arrangement[j]];

                // Number of pills from the mail stamp smart pills
                const numOfPillsActuallyFound: number =
                    aggregatedPills[featureArrangement.arrangement[j]] === undefined
                        ? 0
                        : aggregatedPills[featureArrangement.arrangement[j]];

                // If the number of pills required by our defined arrangement is greater to
                // the ones from mail stamp, then discard this arrangement and break the loop
                // that is comparing every feature
                if (numOfPillsDefined > numOfPillsActuallyFound) {
                    foundMatch = false;
                    break;
                }
            }
            // If there is enough smart pills from every feature, the arrangement can be selected
            if (foundMatch) {
                return featureArrangement;
            }
        }
    }

    return null;
}
